(function () {
'use strict';
var doc = document;
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var designMode = !!(window.Shopify && window.Shopify.designMode);
var wide = window.matchMedia('(min-width: 990px)');
function sTop() { var w = wide.matches && doc.querySelector('.page-wrapper'); return w ? w.scrollTop : window.pageYOffset; }
function initTopbar(scope) {
(scope || doc).querySelectorAll('[data-bkg-top]:not([data-bkg-ready])').forEach(function (bar) {
bar.setAttribute('data-bkg-ready', '');
var msgs = bar.querySelectorAll('.bkg-top__msg');
if (msgs.length < 2 || reduce) return;
var i = 0, delay = (parseFloat(bar.dataset.interval) || 5) * 1000;
setInterval(function () {
msgs[i].classList.remove('is-active');
i = (i + 1) % msgs.length;
msgs[i].classList.add('is-active');
}, delay);
});
}
function initDrawers(scope) {
(scope || doc).querySelectorAll('[data-bkg-drawer-open]:not([data-bkg-ready])').forEach(function (btn) {
btn.setAttribute('data-bkg-ready', '');
var drawer = doc.getElementById(btn.getAttribute('aria-controls'));
if (!drawer) return;
function open() {
drawer.hidden = false;
requestAnimationFrame(function () { drawer.classList.add('is-open'); });
btn.setAttribute('aria-expanded', 'true');
doc.documentElement.style.overflow = 'hidden';
var f = drawer.querySelector('summary, input, button'); f && f.focus({ preventScroll: true });
}
function close() {
drawer.classList.remove('is-open');
btn.setAttribute('aria-expanded', 'false');
doc.documentElement.style.overflow = '';
setTimeout(function () { drawer.hidden = true; }, 450);
btn.focus({ preventScroll: true });
}
btn.addEventListener('click', open);
drawer.querySelectorAll('[data-bkg-drawer-close]').forEach(function (c) { c.addEventListener('click', close); });
drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
var form = drawer.querySelector('[data-bkg-filter-form]');
if (form) {
form.addEventListener('submit', function () {
form.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
});
form.querySelectorAll('input[type="checkbox"]').forEach(function (c) {
c.addEventListener('change', function () { if (window.matchMedia('(min-width: 768px)').matches) form.requestSubmit ? form.requestSubmit() : form.submit(); });
});
}
});
}
var parallaxEls = [];
function initParallax(scope) {
if (reduce) return;
(scope || doc).querySelectorAll('[data-bkg-parallax]:not([data-bkg-ready])').forEach(function (el) {
el.setAttribute('data-bkg-ready', '');
var media = el.querySelector('.bkg-mband__media, .bkg-visit__media');
if (media) parallaxEls.push({ el: el, media: media });
});
tickParallax();
}
function tickParallax() {
var vh = window.innerHeight;
parallaxEls.forEach(function (p) {
var r = p.el.getBoundingClientRect();
if (r.bottom < -100 || r.top > vh + 100) return;
var off = (r.top + r.height / 2 - vh / 2) * -0.08;
p.media.style.setProperty('--bkg-par', off.toFixed(1) + 'px');
});
}
function initGallery3d(scope) {
(scope || doc).querySelectorAll('[data-bkg-g3d]:not([data-bkg-ready])').forEach(function (root) {
root.setAttribute('data-bkg-ready', '');
var stage = root.querySelector('[data-bkg-g3d-stage]');
var ring = root.querySelector('[data-bkg-g3d-ring]');
var items = Array.prototype.slice.call(root.querySelectorAll('[data-bkg-g3d-item]'));
var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bkg-g3d-dot]'));
var n = items.length;
if (!stage || !ring || n < 2) return;
var autoplay = root.dataset.autoplay === 'true' && !reduce;
var scrollLink = root.dataset.scroll === 'true' && !reduce;
var spacing = parseFloat(root.dataset.spacing) || 1.15;
var step = Math.min(360 / n, parseFloat(root.dataset.step) || 24);
var pos = 0, vel = 0, target = null;
var R = 600, w = 380;
var dragging = false, startX = 0, startPos = 0, moved = false, samples = [];
var lastInput = performance.now(), lastAuto = performance.now();
var visible = false, raf = null, last = null;
var lastScrollY = sTop();
function measure() {
w = items[0].offsetWidth || 380;
var gap = w * spacing;
R = Math.max(w * 0.9, (gap / 2) / Math.tan((step * Math.PI / 180) / 2));
ring.style.transform = 'translateZ(' + (-R).toFixed(1) + 'px)';
render();
}
function wrapIndex(i) { return ((i % n) + n) % n; }
function render() {
var front = wrapIndex(Math.round(pos));
items.forEach(function (it, i) {
var d = i - pos;
d = d - n * Math.round(d / n);
var a = d * step;
var abs = Math.abs(a);
it.style.transform = 'rotateY(' + a.toFixed(2) + 'deg) translateZ(' + R.toFixed(1) + 'px)';
it.style.setProperty('--shade', Math.min(0.62, abs / 150).toFixed(3));
it.style.opacity = abs > 96 ? '0' : abs > 80 ? String(((96 - abs) / 16).toFixed(2)) : '1';
it.style.visibility = abs > 96 ? 'hidden' : 'visible';
it.style.zIndex = String(1000 - Math.round(abs));
it.classList.toggle('is-front', i === front && Math.abs(d) < 0.5);
var ig = it.querySelector('a.bkg-g3d__ig');
if (ig) ig.tabIndex = i === front ? 0 : -1;
});
if (dots.length) {
var seg = Math.min(dots.length - 1, Math.floor(front / (n / dots.length)));
dots.forEach(function (d, k) { d.classList.toggle('is-active', k === seg); d.setAttribute('aria-current', k === seg ? 'true' : 'false'); });
}
}
function goTo(index) {
var cur = Math.round(pos);
var diff = wrapIndex(index) - wrapIndex(cur);
if (diff > n / 2) diff -= n;
if (diff < -n / 2) diff += n;
target = cur + diff; vel = 0;
lastInput = performance.now();
wake();
}
function frame(t) {
raf = null;
if (last == null) last = t;
var dt = Math.min((t - last) / 1000, 0.05);
last = t;
var now = performance.now();
if (!dragging) {
if (target != null) {
var diff = target - pos;
pos += diff * (1 - Math.exp(-dt * (reduce ? 60 : 7)));
if (Math.abs(diff) < 0.0008) { pos = target; target = null; }
} else if (Math.abs(vel) > 0.02) {
pos += vel * dt;
vel *= Math.exp(-dt * 3.4);
if (Math.abs(vel) < 0.35) { vel = 0; target = Math.round(pos); }
} else if (now - lastInput > 180 && Math.abs(pos - Math.round(pos)) > 0.001) {
target = Math.round(pos);
} else if (autoplay && !designMode && now - lastInput > 3200 && now - lastAuto > 3200) {
target = Math.round(pos) + 1; lastAuto = now;
}
}
render();
if (visible) raf = requestAnimationFrame(frame);
}
function wake() { if (!raf && visible) { last = null; raf = requestAnimationFrame(frame); } }
stage.addEventListener('pointerdown', function (e) {
if (e.pointerType === 'mouse' && e.button !== 0) return;
dragging = true; moved = false; startX = e.clientX; startPos = pos; target = null; vel = 0;
samples = [{ x: e.clientX, t: performance.now() }];
lastInput = performance.now();
});
window.addEventListener('pointermove', function (e) {
if (!dragging) return;
var dx = e.clientX - startX;
if (!moved && Math.abs(dx) > 6) { moved = true; stage.classList.add('is-dragging'); try { stage.setPointerCapture(e.pointerId); } catch (err) {} }
if (!moved) return;
pos = startPos - dx / (w * 0.95);
var now = performance.now();
samples.push({ x: e.clientX, t: now });
while (samples.length > 2 && now - samples[0].t > 100) samples.shift();
lastInput = now; wake();
});
function end() {
if (!dragging) return;
dragging = false; stage.classList.remove('is-dragging');
if (moved && samples.length > 1) {
var a = samples[0], b = samples[samples.length - 1];
var el = (b.t - a.t) / 1000;
if (el > 0) vel = Math.max(-12, Math.min(12, -((b.x - a.x) / el) / (w * 0.95)));
}
lastInput = performance.now(); wake();
}
window.addEventListener('pointerup', end);
window.addEventListener('pointercancel', end);
items.forEach(function (it, i) {
it.addEventListener('click', function (e) {
if (moved) { e.preventDefault(); return; }
if (!it.classList.contains('is-front')) { e.preventDefault(); goTo(i); }
});
});
dots.forEach(function (d, k) { d.addEventListener('click', function () { goTo(Math.round(k * n / dots.length)); }); });
root.addEventListener('keydown', function (e) {
if (e.key === 'ArrowRight') { goTo(Math.round(pos) + 1); }
if (e.key === 'ArrowLeft') { goTo(Math.round(pos) - 1); }
});
stage.tabIndex = 0;
doc.addEventListener('scroll', function () {
var y = sTop(), dy = y - lastScrollY; lastScrollY = y;
if (!scrollLink || !visible || dragging) return;
pos += dy / 260; target = null; vel = 0; lastInput = performance.now(); wake();
}, { passive: true, capture: true });
if ('IntersectionObserver' in window) {
new IntersectionObserver(function (entries) {
visible = entries[0].isIntersecting;
if (visible) { lastScrollY = sTop(); wake(); }
}, { rootMargin: '100px 0px' }).observe(root);
} else { visible = true; wake(); }
window.addEventListener('resize', measure);
measure();
});
}
function initPaginate(scope) {
(scope || doc).querySelectorAll('[data-bkg-paginate]:not([data-bkg-ready])').forEach(function (root) {
root.setAttribute('data-bkg-ready', '');
var items = Array.prototype.slice.call(root.querySelectorAll('[data-bkg-page-item]'));
var per = parseInt(root.dataset.perPage, 10) || 10;
var nav = root.querySelector('[data-bkg-pages]');
var pages = Math.ceil(items.length / per);
if (!nav || pages < 2) return;
var cur = 0;
function show(p, scroll) {
cur = Math.max(0, Math.min(pages - 1, p));
items.forEach(function (it, i) { it.hidden = Math.floor(i / per) !== cur; });
nav.innerHTML = '';
if (cur > 0) nav.appendChild(btn('‹', cur - 1, 'Previous page', 'bkg-pages__arrow'));
for (var i = 0; i < pages; i++) {
if (i === cur) { var s = doc.createElement('span'); s.className = 'is-current'; s.setAttribute('aria-current', 'page'); s.textContent = i + 1; nav.appendChild(s); }
else nav.appendChild(btn(String(i + 1), i, 'Page ' + (i + 1)));
}
if (cur < pages - 1) nav.appendChild(btn('›', cur + 1, 'Next page', 'bkg-pages__arrow'));
if (scroll) root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
}
function btn(label, p, aria, cls) {
var b = doc.createElement('button'); b.type = 'button'; b.textContent = label; b.setAttribute('aria-label', aria);
if (cls) b.className = cls;
b.addEventListener('click', function () { show(p, true); });
return b;
}
nav.hidden = false;
show(0, false);
});
}
function init(scope) { initTopbar(scope); initDrawers(scope); initParallax(scope); initGallery3d(scope); initPaginate(scope); }
if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(); });
else init();
doc.addEventListener('scroll', function () { requestAnimationFrame(tickParallax); }, { passive: true, capture: true });
window.addEventListener('resize', tickParallax);
doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();